<template lang="pug">
    div.tabs-control(:class="theClass" ref="tabsControl")
        div.tabs-control__tabs(:class='tabsClass')
            div.tabs-control__tab(v-for='tab in tabs' :class='getTabClass(tab.name)'
                    @click='activateTab(tab.name)' ref='tab')
                div.tabs-control__tab-icon(v-if='tab.iconId')
                    svg-icon(:iconId='tab.iconId')
                div.tabs-control__tab-label {{ tab.label }}
            resize-sensor(@resize='updateIndicator')
        
        div.tabs-control__divider
            div.tabs-control__tab-indicator(ref='indicator')

        div.tabs-control__contents
            div.tabs-control__content(v-for='content in contents'
                    v-if='checkSlot(content.slotName) && content.wasActive' :hidden='!content.active')
                slot(:name='content.slotName' :tab='content.tab')
        
        resize-sensor(@resize="checkWidth")
</template>

<script>
import $ from 'jquery'

export default {
    name: 'tabs-control',
    props: {
        value: {
            type: String,
        },
        tabs: {
            type: Array,
            required: true,
        },
        wide: Boolean,
    },
    data() {
        return {
            activeTabName: null,
            contents: null,
            forceCompact: false,
        }
    },
    computed: {
        theClass() {
            return {
                'tabs-control--force-compact': this.forceCompact,
            }
        },
        tabsClass() {
            return {
                'tabs-control__tabs--wide': this.wide,
            }
        },
    },
    watch: {
        value: {
            handler(val) {
                this.activeTabName = val
            },
            immediate: true,
        },
        tabs: {
            handler() {
                this.resetActive()
                this.updateContents()
            },
            deep: true,
            immediate: true,
        },
        activeTabName(val) {
            this.contents.forEach(c => {
                const active = c.tab.name === val
                c.active = active
                if (active) {
                    c.wasActive = true
                }
            })
            this.updateIndicator()
        },
    },
    methods: {
        resetActive() {
            if (!this.activeTabName || !this.tabs.some(t => t.name === this.activeTabName)) {
                this.activateTab(this.tabs[0].name)
            }
        },
        updateContents() {
            this.contents = this.tabs.map(t => {
                const active = this.activeTabName === t.name
                return {
                    slotName: `content-${t.name}`,
                    active,
                    wasActive: active,
                    tab: t,
                }
            })
        },
        activateTab(tabName) {
            this.activeTabName = tabName
            this.$emit('input', tabName)
        },

        getTabClass(tabName) {
            return {
                'tabs-control__tab--active': tabName === this.activeTabName,
            }
        },

        updateIndicator() {
            if (this.$refs.tab) {
                const idx = this.tabs.findIndex(t => t.name === this.activeTabName)
                const tabEl = $(this.$refs.tab[idx])
                const indicatorEl = this.$refs.indicator

                if (tabEl.length) {
                    indicatorEl.style.left = `${parseInt(tabEl.css('marginLeft')) + tabEl.position().left}px`
                    indicatorEl.style.width = `${tabEl.width()}px`
                }
            }
        },

        checkSlot(slotName) {
            return !!this.$slots[slotName]
        },

        checkWidth() {
            if (this.$refs.tab) {
                const tabsWidth = this.$refs.tabsControl.getBoundingClientRect().width
                
                let tabsTotalWidth = 0
                this.$refs.tab.forEach(t => {
                    const style = t.currentStyle || window.getComputedStyle(t)
                    tabsTotalWidth += t.getBoundingClientRect().width + parseFloat(style.marginLeft) + parseFloat(style.marginRight)
                })

                if (tabsWidth < tabsTotalWidth) {
                    this.forceCompact = true
                }
            }
        },
    },
    mounted() {
        this.updateIndicator()
        this.checkWidth()
    },
}
</script>
